"use client";
import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const buttonVariants = cva(
  'inline-flex items-center justify-center rounded-md text-sm font-medium transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[color:var(--color-primary)] disabled:opacity-50 disabled:pointer-events-none active:scale-[0.98]',
  {
    variants: {
      variant: {
        primary: 'bg-[color:var(--color-primary)] text-white hover:bg-[color:var(--color-primary-hover)] hover:shadow-md hover:-translate-y-0.5 active:translate-y-0',
        secondary: 'bg-[color:var(--color-secondary)] text-white hover:bg-[color:var(--color-secondary-hover)] hover:shadow-md hover:-translate-y-0.5 active:translate-y-0',
        accent: 'bg-[color:var(--color-accent)] text-[color:var(--color-dark)] hover:bg-[color:var(--color-accent-hover)] hover:shadow-md hover:-translate-y-0.5 active:translate-y-0',
        outline: 'border-2 border-[color:var(--color-primary)] text-[color:var(--color-primary)] bg-transparent hover:bg-[color:var(--color-primary)] hover:text-white hover:shadow-md',
        ghost: 'bg-transparent text-[color:var(--color-primary)] hover:bg-[color:var(--color-peach-light)] hover:text-[color:var(--color-primary-hover)]',
        link: 'bg-transparent underline-offset-4 hover:underline text-[color:var(--color-primary)] hover:text-[color:var(--color-primary-hover)] px-0',
      },
      size: {
        sm: 'h-9 px-3 text-sm rounded-md',
        md: 'h-11 px-5 text-base rounded-md',
        lg: 'h-12 px-7 text-lg rounded-lg',
        xl: 'h-14 px-8 text-lg rounded-lg',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'md',
    },
  }
);

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {}

export function Button({ className, variant, size, ...props }: ButtonProps) {
  return (
    <button className={cn(buttonVariants({ variant, size }), className)} {...props} />
  );
}
